import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@infra/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('viacep.com.br')) {
      return next.handle(req);
    }

    if (this.authService.accessToken) {
      req = req.clone({
        setHeaders: {
          'x-api-key': `${this.authService.accessToken}`,
          'Authorization': `${this.authService.accessTokenLw}`,
        },
      });

      return next
        .handle(req)
        .pipe(catchError((error) => this.errorHandler(error)));
    } else {
      // Identificar o portal que está fazendo a requisição de autenticação
      // Pegar link atual até o primeiro endpoint
      // Ex: http://localhost:4200/livre/recuperar-senha
      // link-portal: http://localhost:4200/livre

      const linkPortal = window.location.href.split('/').slice(0, 4).join('/');

      req = req.clone({
        setHeaders: {
          'link-portal': linkPortal,
        },
      });

      return next
        .handle(req)
        .pipe(catchError((error) => this.errorHandler(error)));
    }
  }

  private errorHandler(
    response: HttpErrorResponse,
  ): Observable<HttpEvent<any>> {
    const error = {
      title: '',
      icon: '',
      message: response.message,
      status: response.status,
    }

    if (response.error.data?.message) {
      error.message = response.error.data.message;
    }

    console.error(
      `${HttpInterceptorService.name}: status ${error.status}\n${error.message}`,
    );

    switch (response.status) {
      case 0:
        error.icon = 'error';
        error.title = 'Erro';
        error.message = 'Serviço indisponível';
        break;
      case 400:
      case 404:
      case 422:
        error.title = 'Atenção';
        error.icon = 'warning';
        break;
      case 401:
      case 403:
      case 406:
      case 409:
      case 500:
        error.icon = 'error';
        error.title = 'Erro';
        break;
    }

    return throwError(() => error);
  }
}
